import { createReducer, on } from '@ngrx/store';
import { produce } from 'immer';

import * as IntelliActions from './intellisense.actions';
import { type IntellisenseState } from './intellisense.state';

export const INTELLISENSE_FEATURE_KEY = 'intellisense';

export const initialState: IntellisenseState = {
  context: {},
};

export const reducer = createReducer(
  initialState,

  on(IntelliActions.contextUpdated, (state, { ctx }) =>
    produce(state, (draft) => {
      draft.context = ctx;
      return draft;
    }),
  ),
);
